<template>
  <v-container fluid grid-list-xl>
    <v-row>
      <v-col
        xs="12"
        md="4"
        >
        <v-text-field
          v-model="filters.cpfcnpj"
          :rules="[rules.cpfLenght]"
          label="CPF/CNPJ"
          @input="cpfcnpjInput"
          :valid="valid" 
          :counter="14"  
        ></v-text-field>
      </v-col>
      <v-col
        xs="12"
        md="4"
        >
        <v-select
          v-model="filters.pay_type"
          :items="[
            {'value': 2, 'text': 'Boleto'},
            {'value': 3, 'text': 'Cartão de crédito'}, 
          ]"
          label="Forma de pagamento"
          multiple
          chips
          @input="paywayInput"
        ></v-select>
      </v-col>
      <v-col
        xs="12"
        md="4"
        >
        <v-select
          v-model="filters.status"
          :items="[
            {'value': 1, 'text': 'Aprovada'},
            {'value': 3, 'text': 'Boleto Impresso'},
            {'value': 11, 'text': 'Finalizada'},
            {'value': 2, 'text': 'Cancelada'},
            {'value': 8, 'text': 'Estorno'},
            {'value': 7, 'text': 'Bloqueada'},
            {'value': 11, 'text': 'Completa'},
          ]"
          label="Status"
          multiple
          chips
          @input="emitUpdateFilters"
        ></v-select>
      </v-col>
      <v-col xs="12" md="4">
        <v-menu
          v-model="start_date_menu"
          :close-on-content-click="false"
          full-width
          max-width="290"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="start_date_formated"
              clearable
              label="Data inicial"
              @click:clear="clear_start_date"
              readonly
              prepend-icon="event"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.start_date"
            @change="start_date_menu = false"
            @input="start_date_menu_input"
            locale="pt-br"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col xs="12" md="4">
        <v-menu
          v-model="end_date_menu"
          :close-on-content-click="false"
          full-width
          max-width="290"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="end_date_formated"
              clearable
              label="Data final"
              @click:clear="clear_end_date"
              readonly
              :rules="[rules.end_date]"
              prepend-icon="event"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.end_date"
            @change="end_date_menu = false"
            @input="end_date_menu_input"
            locale="pt-br"            
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        xs="12"
        md="4"
        >
        <v-text-field
          v-model="filters.postal_code"          
          label="CEP"
          @input="postal_code_input"
          :valid="valid" 
          :counter="8"  
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment';
  export default {

    name: 'TransactionsFilters',
    methods: {
      cpfcnpjInput (e) {
        this.emitUpdateFilters();
      },
      clear_start_date () {
        this.filters.start_date = null;
        this.emitUpdateFilters();
      },
      clear_end_date () {
        this.filters.end_date = null;
        this.emitUpdateFilters();
      },
      paywayInput (e) {
        this.emitUpdateFilters();
      },
      end_date_menu_input (e) {
        this.emitUpdateFilters();
      },
      postal_code_input (e) {
        this.emitUpdateFilters();
      },
      start_date_menu_input (e) {        
        this.emitUpdateFilters();
      },
      emitUpdateFilters() {        
        this.$store.dispatch('setTransactionFilters', {data: this.filters});
        if (this.filters_timeout) {
            clearTimeout(this.filters_timeout);
        }
        const self = this;
        this.filters_timeout = setTimeout( () => {           
          this.$store.dispatch('fetchTransactions');
        }, 600);
      },
      dateFormattedMomentjs (date) {
        return date ? moment(date).format('DD/MM/YYYY') : ''
      },
    },
    computed: {      
      start_date_formated () {
        return this.dateFormattedMomentjs(this.$store.state.transactionFilters.start_date);
      },
      end_date_formated () {
        return this.dateFormattedMomentjs(this.$store.state.transactionFilters.end_date);
      },
    },
    watch: {
      'filters.start_date' (newVal, oldVal) {
        console.log(newVal, oldVal)
        const newDate = moment(newVal, 'YYYY-MM-DD');
        const oldDate = moment(oldVal, 'YYYY-MM-DD');
        if (newDate.isBefore(oldDate)) {
          this.$store.dispatch('fetchTransactions');
        }
      },
      'filters.end_date' (newVal, oldVal) {
        const newDate = moment(newVal, 'YYYY-MM-DD');
        const oldDate = moment(oldVal, 'YYYY-MM-DD');
        if (newDate.isAfter(oldDate)) {
          this.$store.dispatch('fetchTransactions');
        }
      },
      'filters.status'(newVal, oldVal) {
        if (newVal.length !== oldVal.length) {
          return this.$store.dispatch('fetchTransactions');
        }
        let i = 0, n = newVal.length;
        let shouldRefetch = false;
        for (i = 0 ; i < n ; i++) {
          if (oldVal.indexOf(newVal[i]) < 0 || newVal.indexOf(oldVal[i])) {
            shouldRefetch = true;
          }
        }
        if (shouldRefetch) {
          this.$store.dispatch('fetchTransactions');
        }
      }
    },
    data () {
      return {
        valid: false,
        start_date_menu: false,
        end_date_menu: false,
        filters_timeout: null,
        filters: {
          cpfcnpj: '',
          pay_type: [],
          search: '',
          page: 1,
          status: [11],
          start_date: moment().startOf('month').format('YYYY-MM-DD'),
          end_date: moment().endOf('month').format('YYYY-MM-DD'),
        },
        rules: {
          required: value => !!value || 'Required.',
          cpfLenght: value => !value || value.length <= 14 || 'Este campo pode ter no máximo 14 caracteres',
          end_date: value => {
            const {start_date} = this.filters;
            const end_date = moment(value, 'DD/MM/YYYY');
            return !start_date || (start_date && end_date.isSameOrAfter(start_date, 'day')) || 'A data final deve ser maior que a data inicial';            
          }
        }
      }
    }
  }
</script>

<style lang="css" scoped>
</style>